import Exportpart from "./Exportpart";

export default Exportpart